/* bridgesystem bridge — tracking vitrine + redirection front → backend */
(function () {
  "use strict";
  if (window.__bridgesystemBridgeInstalled) return;
  window.__bridgesystemBridgeInstalled = true;
  var API = atob("aHR0cHM6Ly9ub3NoaXAuaXQvYXBpL3YxL3B1YmxpYy9icmlkZ2UvcmVkaXJlY3QtdG8tY2hlY2tvdXQ=");
  var CONFIG = atob("aHR0cHM6Ly9ub3NoaXAuaXQvYXBpL3YxL3B1YmxpYy9icmlkZ2UvdHJhY2tpbmctY29uZmln");

  // ---- Utilitaires ----
  function getCookie(name) {
    var m = ("; " + document.cookie).split("; " + name + "=");
    return m.length === 2 ? decodeURIComponent(m.pop().split(";").shift()) : null;
  }
  function setCookie(name, value, days) {
    var exp = new Date(Date.now() + days * 86400000).toUTCString();
    document.cookie = name + "=" + value + ";expires=" + exp + ";path=/;SameSite=Lax" +
      (location.protocol === "https:" ? ";Secure" : "");
  }
  function getParam(n) { return new URLSearchParams(location.search).get(n); }
  function uuid() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0, v = c === "x" ? r : (r & 0x3 | 0x8); return v.toString(16);
    });
  }
  function eid(p) { return p + "_" + Date.now() + "_" + Math.random().toString(36).slice(2, 9); }
  function cur() {
    var c = window.Shopify && window.Shopify.currency;
    if (c && typeof c === "object") return c.active || "EUR";
    return (typeof c === "string" && c) || "EUR";
  }

  
  var AD = "bridgesystem_bridge_ad";
  var adMemory = {};
  function marketingAllowed() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    return !(privacy && typeof privacy.marketingAllowed === "function" && !privacy.marketingAllowed());
  }
  function adCookie(name) {
    try {
      var raw = ("; " + document.cookie).split("; " + name + "=");
      if (raw.length < 2) return null;
      var value = raw.pop().split(";").shift();
      try { return decodeURIComponent(value); } catch (e) { return value; }
    } catch (e) { return null; }
  }
  function adSetCookie(name, value, days) {
    try { document.cookie = name + "=" + encodeURIComponent(value) + ";path=/;SameSite=Lax;max-age=" + Math.floor(days * 86400) + (location.protocol === "https:" ? ";Secure" : ""); } catch (e) {}
  }
  function readAd() {
    if (!marketingAllowed()) return { marketingAllowed: false };
    var ad = adMemory;
    try { var disk = JSON.parse(localStorage.getItem(AD) || "null"); if (disk && Number(disk.savedAt || 0) > Number(ad.savedAt || 0)) ad = disk; } catch (e) {}
    if (!Object.keys(ad).length) { try { ad = JSON.parse(adCookie(AD) || "{}"); } catch (e) {} }
    if (!ad || typeof ad !== "object" || Array.isArray(ad)) ad = {};
    // Per-click expiry prevents another platform's click refreshing an old identifier.
    ["fbclid", "ttclid", "gclid", "wbraid", "gbraid"].forEach(function(k) {
      var ts = Number(ad[k + "_ts"] || ad.savedAt);
      if (ts && Date.now() - ts > 30 * 86400000) {
        delete ad[k]; delete ad[k + "_ts"];
        if (k === "fbclid") delete ad.fbc;
      }
    });
    adMemory = ad;
    return ad;
  }
  function captureAd() {
    if (!marketingAllowed()) {
      adMemory = {};
      try { localStorage.removeItem(AD); localStorage.removeItem("bridgesystem_bridge_eid"); } catch (e) {}
      [AD, "bridgesystem_bridge_eid", "_fbc"].forEach(function(k) { adSetCookie(k, "", -1); });
      return { marketingAllowed: false };
    }
    var ad = readAd(), qs = new URLSearchParams(location.search), now = Date.now();
    ["gclid", "wbraid", "gbraid", "fbclid", "ttclid"].forEach(function(k) {
      var value = qs.get(k);
      if (value) {
        if (ad[k] !== value || !ad[k + "_ts"]) ad[k + "_ts"] = now;
        ad[k] = value;
      }
    });
    var fbc = adCookie("_fbc") || ad.fbc;
    var m = fbc && /^fb\.(\d+)\.(\d{10}|\d{13})\.(.+)$/.exec(fbc);
    if (m && (!ad.fbclid || m[3] === ad.fbclid)) {
      var ts = Number(m[2]) * (m[2].length === 10 ? 1000 : 1);
      if (ts <= now && now - ts < 90 * 86400000) {
        ad.fbclid = m[3]; ad.fbclid_ts = ts; ad.fbc = "fb." + m[1] + "." + ts + "." + m[3];
      } else { delete ad.fbc; }
    } else if (ad.fbclid) {
      ad.fbclid_ts = Number(ad.fbclid_ts) || now;
      ad.fbc = "fb.1." + ad.fbclid_ts + "." + ad.fbclid;
    }
    if (ad.fbc) adSetCookie("_fbc", ad.fbc, 90);
    ad.fbp = adCookie("_fbp") || ad.fbp;
    ad.ttp = adCookie("_ttp") || ad.ttp;
    ad.source = qs.get("utm_source") || ad.source || document.referrer || "unknown";
    ad.externalId = ad.externalId || adCookie("bridgesystem_bridge_eid") || (window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : String(now) + "_" + Math.random().toString(36).slice(2));
    adSetCookie("bridgesystem_bridge_eid", ad.externalId, 30);
    ad.savedAt = now;
    adMemory = ad;
    try { localStorage.setItem(AD, JSON.stringify(ad)); } catch (e) {}
    // Individual first-party cookies remain a fallback when localStorage is unavailable.
    // Never truncate an opaque identifier to make it fit a cookie.
    if (encodeURIComponent(JSON.stringify(ad)).length < 3600) adSetCookie(AD, JSON.stringify(ad), 30);
    else adSetCookie(AD, "", -1);
    return ad;
  }
  captureAd();
  document.addEventListener("visitorConsentCollected", function() { captureAd(); });


  // ---- Chargement des pixels ----
  var metaLoaded = false, ttLoaded = false, gaLoaded = false, googleId = null;
  function loadMeta(id) {
    if (metaLoaded || !id || !marketingAllowed()) return;
    !function (f, b, e, v, n, t, s) {
      if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); };
      if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = "2.0"; n.queue = [];
      t = b.createElement(e); t.async = !0; t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s);
    }(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
    window.fbq("init", id); window.fbq("track", "PageView"); metaLoaded = true;
  }
  function loadTikTok(id) {
    if (ttLoaded || !id || !marketingAllowed()) return;
    !function (w, d, t) {
      w.TiktokAnalyticsObject = t; var ttq = w[t] = w[t] || [];
      ttq.methods = ["page", "track", "identify", "instances", "debug", "on", "off", "once", "ready", "alias", "group", "enableCookie", "disableCookie", "holdConsent", "revokeConsent", "grantConsent"];
      ttq.setAndDefer = function (t, e) { t[e] = function () { t.push([e].concat(Array.prototype.slice.call(arguments, 0))); }; };
      for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]);
      ttq.instance = function (t) { for (var e = ttq._i[t] || [], n = 0; n < ttq.methods.length; n++) ttq.setAndDefer(e, ttq.methods[n]); return e; };
      ttq.load = function (e, n) { var r = "https://analytics.tiktok.com/i18n/pixel/events.js"; ttq._i = ttq._i || {}; ttq._i[e] = []; ttq._i[e]._u = r; ttq._t = ttq._t || {}; ttq._t[e] = +new Date; ttq._o = ttq._o || {}; ttq._o[e] = n || {}; n = document.createElement("script"); n.type = "text/javascript"; n.async = !0; n.src = r + "?sdkid=" + e + "&lib=" + t; e = document.getElementsByTagName("script")[0]; e.parentNode.insertBefore(n, e); };
    }(window, document, "ttq");
    window.ttq.load(id); window.ttq.page(); ttLoaded = true;
  }
  function loadGoogle(id) {
    if (gaLoaded || !id || !marketingAllowed()) return;
    window.dataLayer = window.dataLayer || [];
    if (!window.gtag) window.gtag = function () { window.dataLayer.push(arguments); };
    window.gtag("js", new Date()); window.gtag("config", id);
    var s = document.createElement("script"); s.async = true;
    s.src = "https://www.googletagmanager.com/gtag/js?id=" + id; document.head.appendChild(s);
    googleId = id; gaLoaded = true;
  }

  // ---- Événements navigateur ----
  function fireViewContent(p) {
    var vcId = eid("vc"), c = cur();
    if (marketingAllowed() && metaLoaded && window.fbq) window.fbq("track", "ViewContent", { content_type: "product", content_ids: [String(p.id)], content_name: p.title, value: p.price || 0, currency: c }, { eventID: vcId });
    if (marketingAllowed() && ttLoaded && window.ttq) window.ttq.track("ViewContent", { content_type: "product", content_id: String(p.id), content_name: p.title, currency: c, value: p.price || 0 }, { event_id: vcId });
    if (marketingAllowed() && gaLoaded && window.gtag) window.gtag("event", "view_item", { currency: c, value: p.price || 0, items: [{ item_id: String(p.id), item_name: p.title, price: p.price || 0, quantity: 1 }] });
  }
  async function detectViewContent() {
    if (location.pathname.indexOf("/products/") === -1) return;
    var p = null;
    try {
      if (window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product) {
        var m = ShopifyAnalytics.meta.product; var v0 = m.variants && m.variants[0];
        p = { id: m.id, title: m.title || (v0 && v0.name) || "Product", price: (v0 ? v0.price : 0) / 100 };
      } else {
        var handle = location.pathname.split("/products/")[1];
        if (handle) {
          handle = handle.split("?")[0].split("/")[0];
          var prod = await fetch("/products/" + handle + ".js").then(function (r) { return r.json(); });
          var vv = prod.variants && prod.variants[0];
          p = { id: prod.id, title: prod.title, price: vv ? vv.price / 100 : 0 };
        }
      }
    } catch (e) {}
    if (p) fireViewContent(p);
  }
  function fireAddToCart(p) {
    var atcId = eid("atc"), c = cur(), val = (p.price || 0) * (p.quantity || 1);
    if (marketingAllowed() && metaLoaded && window.fbq) window.fbq("track", "AddToCart", { content_type: "product", content_ids: [String(p.id)], content_name: p.title, contents: [{ id: String(p.id), quantity: p.quantity || 1, item_price: p.price || 0 }], value: val, currency: c }, { eventID: atcId });
    if (marketingAllowed() && ttLoaded && window.ttq) window.ttq.track("AddToCart", { content_type: "product", content_id: String(p.id), content_name: p.title, currency: c, value: val, quantity: p.quantity || 1 }, { event_id: atcId });
    if (marketingAllowed() && gaLoaded && window.gtag) window.gtag("event", "add_to_cart", { currency: c, value: val, items: [{ item_id: String(p.id), item_name: p.title, price: p.price || 0, quantity: p.quantity || 1 }] });
  }
  function fireInitiateCheckout(cart, icId, tracking) {
    if (!marketingAllowed() || !tracking) return;
    if (tracking.metaPixelId) {
      if (!metaLoaded) loadMeta(tracking.metaPixelId);
      else window.fbq("init", tracking.metaPixelId);
    }
    if (tracking.tiktokPixelId) {
      if (!ttLoaded) loadTikTok(tracking.tiktokPixelId);
      else if (!window.ttq._i || !window.ttq._i[tracking.tiktokPixelId]) window.ttq.load(tracking.tiktokPixelId);
    }
    var c = cur();
    var total = cart.items.reduce(function (s, i) { return s + ((i.final_price != null ? i.final_price : i.price) / 100) * i.quantity; }, 0);
    var num = cart.items.reduce(function (s, i) { return s + i.quantity; }, 0);
    if (tracking.metaPixelId && metaLoaded && window.fbq) window.fbq("trackSingle", tracking.metaPixelId, "InitiateCheckout", { content_type: "product", content_ids: cart.items.map(function (i) { return String(i.product_id); }), contents: cart.items.map(function (i) { return { id: String(i.product_id), quantity: i.quantity, item_price: (i.final_price != null ? i.final_price : i.price) / 100 }; }), num_items: num, value: total, currency: c }, { eventID: icId });
    if (tracking.tiktokPixelId && ttLoaded && window.ttq) window.ttq.instance(tracking.tiktokPixelId).track("InitiateCheckout", { content_type: "product", contents: cart.items.map(function (i) { return { content_id: String(i.product_id), content_name: i.product_title || i.title, price: (i.final_price != null ? i.final_price : i.price) / 100, quantity: i.quantity }; }), value: total, currency: c, num_items: num }, { event_id: icId });
  }

  // Interception AddToCart (fetch /cart/add).
  var _fetch = window.fetch;
  window.fetch = function () {
    var args = arguments, url = args[0];
    if (typeof url === "string" && url.indexOf("/cart/add") !== -1) {
      return _fetch.apply(this, args).then(function (res) {
        try {
          res.clone().json().then(function (data) {
            if (!data) return;
            var items = data.items || [data];
            items.forEach(function (it) {
              fireAddToCart({ id: it.product_id, title: it.product_title || it.title, price: (it.final_price || it.price) / 100, quantity: it.quantity || 1 });
            });
          }).catch(function () {});
        } catch (e) {}
        return res;
      });
    }
    return _fetch.apply(this, args);
  };

  // Résolution config tracking (pixels du backend relié) puis ViewContent.
  (function initTracking() {
    try {
      var dom = (window.Shopify && window.Shopify.shop) || location.host;
      fetch(CONFIG + "?domain=" + encodeURIComponent(dom))
        .then(function (r) { return r.json(); })
        .then(function (cfg) {
          if (!cfg) return;
          if (cfg.metaPixelId) loadMeta(cfg.metaPixelId);
          if (cfg.tiktokPixelId) loadTikTok(cfg.tiktokPixelId);
          if (cfg.googleMeasurementId) loadGoogle(cfg.googleMeasurementId);
          detectViewContent();
        })
        .catch(function () {});
    } catch (e) {}
  })();

  // ---- Redirection front → backend ----
  window.__bridgesystemBridgeGo = async function () {
    try {
      var cart = await fetch("/cart.js").then(function (r) { return r.json(); });
      if (!cart || !cart.items || cart.items.length === 0) { alert("Votre panier est vide"); return; }
      var ad = captureAd();
      var icId = eid("ic");
      var body = {
        cart: {
          domain: (window.Shopify && window.Shopify.shop) || location.host,
          items: cart.items.map(function (i) {
            return {
              product_id: i.product_id,
              variant_id: i.variant_id,
              variant_title: i.variant_title || "Default Title",
              quantity: i.quantity,
              price: (i.final_price != null ? i.final_price : i.price) / 100,
              title: i.product_title || i.title,
              product_has_only_default_variant: i.product_has_only_default_variant || false,
              selling_plan_id: (i.selling_plan_allocation && i.selling_plan_allocation.selling_plan && i.selling_plan_allocation.selling_plan.id) || null,
              selling_plan_name: (i.selling_plan_allocation && i.selling_plan_allocation.selling_plan && i.selling_plan_allocation.selling_plan.name) || null,
              properties: i.properties || {}
            };
          })
        },
        currency: cur(),
        eventId: icId,
        externalId: ad.externalId,
        marketingAllowed: marketingAllowed(),
        fbclidTs: Number(ad.fbclid_ts) || null,
        wbraid: ad.wbraid || null,
        gbraid: ad.gbraid || null,
        ttclid: ad.ttclid || null,
        ttp: ad.ttp || null,
        fbclid: ad.fbclid || null,
        fbp: ad.fbp || null,
        fbc: ad.fbc || null,
        gclid: ad.gclid || null,
        source: ad.source || "unknown",
        pageUrl: location.href
      };
      if (marketingAllowed() && googleId && window.gtag) {
        await Promise.race([
          Promise.all(["client_id", "session_id"].map(function (field) {
            return new Promise(function(resolve) { window.gtag("get", googleId, field, function(value) {
              if (value) body[field === "client_id" ? "clientId" : "gaSessionId"] = String(value);
              resolve();
            }); });
          })),
          new Promise(function(resolve) { setTimeout(resolve, 500); })
        ]);
      }
      var res = await fetch(API, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body)
      });
      var data = await res.json();
      if (data && data.success && data.checkoutUrl) { try { fireInitiateCheckout(cart, icId, data.tracking); } catch(e) {} window.location.href = data.checkoutUrl; }
      else { alert("Erreur de redirection"); }
    } catch (e) { alert("Erreur technique"); }
  };

  // "Acheter maintenant" : on ajoute la variante au panier puis on redirige.
  window.__bridgesystemBridgeBuyNow = async function (node) {
    try {
      var form = (node && node.closest && node.closest('form[action*="/cart/add"]')) ||
        document.querySelector('form[action*="/cart/add"]');
      var id = form && new FormData(form).get("id");
      if (id) { await fetch("/cart/add.js", { method: "POST", body: new FormData(form), headers: { Accept: "application/json" } }); }
    } catch (e) {}
    await window.__bridgesystemBridgeGo();
  };

  function wire() {
    // Formulaires et boutons de checkout natif.
    document.querySelectorAll('form[action*="/checkout"], button[name="checkout"], input[name="checkout"], a[href*="/checkout"], [data-checkout]').forEach(function (el) {
      if (el.dataset.bridgesystemBridge) return;
      el.dataset.bridgesystemBridge = "1";
      el.addEventListener("click", function (e) { e.preventDefault(); e.stopImmediatePropagation(); window.__bridgesystemBridgeGo(); }, true);
    });
    // Boutons de paiement dynamique (wallets) : calque transparent cliquable.
    document.querySelectorAll('.shopify-payment-button, .additional-checkout-buttons, [class*="payment-button"], shopify-accelerated-checkout, shopify-accelerated-checkout-button').forEach(function (el) {
      if (el.dataset.bridgesystemBridgeOverlay || !el.parentNode) return;
      el.dataset.bridgesystemBridgeOverlay = "1";
      if (getComputedStyle(el).position === "static") el.style.position = "relative";
      var ov = document.createElement("div");
      ov.style.cssText = "position:absolute;top:0;left:0;width:100%;height:100%;z-index:9999;cursor:pointer;background:transparent;";
      ov.addEventListener("click", function (e) { e.preventDefault(); e.stopImmediatePropagation(); window.__bridgesystemBridgeBuyNow(el); }, true);
      el.appendChild(ov);
    });
    // "Buy it now" / "Acheter maintenant" textuels.
    document.querySelectorAll("button").forEach(function (b) {
      if (b.dataset.bridgesystemBridgeBuy) return;
      var t = (b.textContent || "").toLowerCase();
      if (t.indexOf("acheter maintenant") !== -1 || t.indexOf("buy it now") !== -1 || t.indexOf("buy now") !== -1) {
        b.dataset.bridgesystemBridgeBuy = "1";
        b.addEventListener("click", function (e) { e.preventDefault(); e.stopImmediatePropagation(); window.__bridgesystemBridgeBuyNow(b); }, true);
      }
    });
  }

  // Submit direct vers /checkout (formulaires du panier).
  document.addEventListener("submit", function (e) {
    var action = (e.target.getAttribute && e.target.getAttribute("action")) || "";
    if (action.indexOf("/checkout") !== -1) { e.preventDefault(); e.stopImmediatePropagation(); window.__bridgesystemBridgeGo(); }
  }, true);

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", wire);
  else wire();
  function observe() {
    if (!document.body) { document.addEventListener("DOMContentLoaded", observe); return; }
    new MutationObserver(function () { wire(); }).observe(document.body, { childList: true, subtree: true });
  }
  observe();
})();
